import { type Children } from "@alloy-js/core";

import { BlockScope } from "./BlockScope.jsx";

export interface IfStatementProps {
  condition: Children;
  children: Children;
}

/**
 * An if statement.
 */
export function IfStatement(props: IfStatementProps) {
  return (
    <>
      if ({props.condition}) <BlockScope>{props.children}</BlockScope>
    </>
  );
}

export interface ElseIfClauseProps {
  condition: Children;
  children: Children;
}

/**
 * An else clause with an if statement.
 */
export function ElseIfClause(props: ElseIfClauseProps) {
  return (
    <>
      {" "}
      else if ({props.condition}) <BlockScope>{props.children}</BlockScope>
    </>
  );
}

export interface ElseClauseProps {
  children: Children;
}

/**
 * The else clause of an if statement.
 */
export function ElseClause(props: ElseClauseProps) {
  return (
    <>
      {" "}
      else <BlockScope>{props.children}</BlockScope>
    </>
  );
}
